import { usePendingFitMapOnMount } from '@/map'

export function ApplyPendingFitMapOnMount() {
  usePendingFitMapOnMount()

  return null
}
